import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/netmatchFail',
      name: 'netmatchFail',
      component: () => import('@/page/netmatchFail/netmatchFail.vue'),
      meta: {
        title: '配网失败',
        keepAlive: false
      }
    },
    {
      path: '/helpFeedback',
      name: 'helpFeedback',
      component: () => import('@/page/helpFeedback/helpFeedback.vue'),
      meta: {
        title: '帮助与反馈',
        keepAlive: false

      }
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: () => import('@/page/feedback/feedback.vue'),
      meta: {
        title: '反馈',
        keepAlive: false
      }
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: () => import('@/page/contactUs/contactUs.vue'),
      meta: {
        title: '联系我们',
        keepAlive: false
      }
    },
    {
      path: '/generalContent',
      name: 'generalContent',
      component: () => import('@/page/generalContent/generalContent.vue'),
      meta: {
        title: '通用内容页面',
        keepAlive: false
      }
    },
    {
      path: '/secretPolicy',
      name: 'secretPolicy',
      component: () => import('@/page/secretPolicy/secretPolicy.vue'),
      meta: {
        title: '隐私政策',
        keepAlive: false
      }
    },

    {
      path: '/capacityExpansion',
      name: 'capacityExpansion',
      component: () => import('@/page/capacityExpansion/capacityExpansion.vue'),
      meta: {
        title: '扩容',
        keepAlive: false
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/page/about/about.vue'),
      meta: {
        title: '关于',
        keepAlive: false
      }
    },
    {
      path: '/invite',
      name: 'invite',
      component: () => import('@/page/invite/invite.vue'),
      meta: {
        title: '邀请',
        keepAlive: false
      }
    },
    {
      path: `/acceptInvite/:id`,
      // path: `/acceptInvite`,
      name: 'acceptInvite',
      component: () => import('@/page/acceptInvite/acceptInvite.vue'),
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/acceptPage',
      name: 'acceptPage',
      component: () => import('@/page/acceptInvite/acceptPage/acceptPage.vue'),
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {

      path: '/downPage',
      name: 'downPage',
      component: () => import('@/page/acceptInvite/downPage/downPage.vue'),
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/share/:id/:name',
      name: 'share',
      component: () => import('@/page/share/share.vue'),
      meta: {
        title: '',
        keepAlive: false
      }
    },
    {
      path: '/shareFile',
      name: 'shareFile',
      component: () => import('@/page/share/shareFile/shareFile.vue'),
      meta: {
        title: '',
        keepAlive: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js